import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { ProgressBarSteps } from '../../types/Cashier';

import styles from './ProgressBar.scss';
import BonusStepActive from './ProgressBars/BonusStepActive/BonusStepActive';
import StepOneActive from './ProgressBars/StepOneActive/StepOneActive';
import StepThreeActive from './ProgressBars/StepThreeActive/StepThreeActive';
import StepTwoActive from './ProgressBars/StepTwoActive/StepTwoActive';
import StepOneCompleted from './ProgressBarsModal/StepOneCompleted/StepOneCompleted';
import StepThreeCompleted from './ProgressBarsModal/StepThreeCompleted/StepThreeCompleted';
import StepTwoCompleted from './ProgressBarsModal/StepTwoCompleted/StepTwoCompleted';

interface Props {
  progressBarCompletedSteps?: boolean;
}

const ProgressBar: React.FC<Props> = ({ progressBarCompletedSteps }) => {
  const {
    data: { signupPassed, rmfPassed, progressBarStep }
  } = useWizardContext();

  let children: React.ReactNode;
  const isSignup = !signupPassed;
  const isRmf = signupPassed && (!rmfPassed || progressBarStep === ProgressBarSteps.AboutYou);
  const isDeposit = rmfPassed && progressBarStep === ProgressBarSteps.Deposit;
  const isBonus = rmfPassed && progressBarStep === ProgressBarSteps.Bonus;

  if (progressBarCompletedSteps) {
    switch (true) {
      case isRmf:
        children = (
          <StepOneCompleted classname={styles.completedStepModal} vectorClassname={styles.vector} />
        );
        break;
      case isDeposit:
        children = (
          <StepTwoCompleted classname={styles.completedStepModal} vectorClassname={styles.vector} />
        );
        break;
      case isBonus:
        children = (
          <StepThreeCompleted
            classname={styles.completedStepModal}
            vectorClassname={styles.vector}
          />
        );
        break;
    }
    return <div className={styles.progressBarModal}>{children}</div>;
  }

  switch (true) {
    case isSignup:
      children = <StepOneActive classname={styles.active} />;
      break;
    case isRmf:
      children = <StepTwoActive classname={styles.active} />;
      break;
    case isDeposit:
      children = <StepThreeActive classname={styles.active} />;
      break;
    case isBonus:
      children = <BonusStepActive classname={styles.active} />;
      break;
  }
  return <div className={styles.progressBar}>{children}</div>;
};

export default ProgressBar;
